import { type Course, type SingleSessionResult } from '@mc/api'
import { TRACK_CONTENT_TYPES } from '@mc/track-event'
import VideoModal from 'components/VideoModal'
import { getCourseModalText } from 'components/VideoModal/getCourseModalText'
import { useCourseOrSessionBySlug } from 'libs/client/api'
import { useQRCTAHref } from 'pages/find-my-classes/hooks'
import { useVideoContext } from './useVideoContext'

const isSession = (
  content: Course | SingleSessionResult | undefined,
): content is SingleSessionResult => !!content && 'campModules' in content

export const TrailerModal = () => {
  const { isModalOpen, currentContent, closeVideo } = useVideoContext()
  const { contentBySlug: content } = useCourseOrSessionBySlug(
    currentContent?.slug,
    currentContent?.type,
  )

  // useQRCTAHref() will return undefined if the user is not on the quiz results page
  // and trailer modal will redirect to the value of the usePrimaryCta hook
  const ctaHref = useQRCTAHref()

  if (!content) return null

  const mediaUuid = isSession(content)
    ? content.trailer.mediaUuid
    : content.mediaUuid

  const brightcoveId = isSession(content)
    ? content.trailer.brightcoveVideoId
    : content.brightcoveVideoId

  const modalText = isSession(content)
    ? {
        modalTitle:
          content.instructors
            ?.map((instructor) => instructor.name)
            .join(', ') ?? content.title,
        tagline: content.title,
      }
    : getCourseModalText(content)

  return (
    <VideoModal
      show={isModalOpen}
      onCloseModal={closeVideo}
      mediaUuid={mediaUuid}
      trackProps={{ uuid: content.uuid }}
      {...modalText}
      contentId={`${content.id}_${brightcoveId ?? mediaUuid}`}
      contentTitle={content.title}
      contentType={
        isSession(content)
          ? TRACK_CONTENT_TYPES.CAMP_TRAILER
          : TRACK_CONTENT_TYPES.COURSE_TRAILER
      }
      courseId={content.id}
      instructorAvatar={content.primary1x1}
      signUpHref={ctaHref}
    />
  )
}
